import { useEffect } from "react";
import InputAHSF from "../../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import { GetApplicationInfoBySubTaskId } from "../../../../Redux/Reducers/Manager/SubTask";
import { useParams } from "react-router-dom";

const ApplicationInfoEval = (props) => {
  const dispatch = useDispatch();
   const lang = useSelector((state) => state.languageReducer.Language);
  const { subTaskId } = useParams();
  const ApplicationBySubTask = useSelector(
    (state) => state.SubTask.ApplicationBySubTask
  );
  useEffect(() => {
    dispatch(GetApplicationInfoBySubTaskId({ subTaskId: subTaskId ,lang:lang=="en"?true:false}));
  }, [props.refrish]);

  return (
    <>
      <div className="form-grid">
        <InputAHSF
          fieldsName="ApplicationNumberInput"
          show={true}
          lang={lang}
          disabled={true}
          value={ApplicationBySubTask?.applicationNumber}
          showValidationMessage={false}
        />
        <InputAHSF
          fieldsName="fullName"
          show={true}
          lang={lang}
          disabled={true}
          value={ApplicationBySubTask?.applicantfullName}
          showValidationMessage={false}
        />
        <InputAHSF
          fieldsName="field"
          show={true}
          lang={lang}
          disabled={true}
          value={ApplicationBySubTask?.fieldName}
          showValidationMessage={false}
        />

        <InputAHSF
          fieldsName="topic"
          show={true}
          lang={lang}
          disabled={true}
          value={ApplicationBySubTask?.subjectName}
          showValidationMessage={false}
        />
        <InputAHSF
          fieldsName="evalName"
          show={true}
          lang={lang}
          disabled={true}
          value={ApplicationBySubTask?.evalfullName}
          showValidationMessage={false}
        />
        {/* <InputAHSF
          fieldsName="totalMarks"
          show={true}
          lang={lang}
          disabled={true}
          value={ApplicationBySubTask?.totalMark}
          showValidationMessage={false}
        /> */}
      </div>
    </>
  );
};
export default ApplicationInfoEval;
